module.exports = __webpack_public_path__ + "img/Passed.d0b8cd03.png";